// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkSpace_cardContainer__Atro8 {
    padding: 10% 10%;
}

.WorkSpace_dashboardContaier__DL55f {
    margin-top: 8%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/WorkSpace/WorkSpace.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".cardContainer {\n    padding: 10% 10%;\n}\n\n.dashboardContaier {\n    margin-top: 8%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `WorkSpace_cardContainer__Atro8`,
	"dashboardContaier": `WorkSpace_dashboardContaier__DL55f`
};
export default ___CSS_LOADER_EXPORT___;
